import React from 'react'
import { Stack, Typography } from '@mui/material'
import Button from 'src/components/Button'
import { useAlert } from 'src/context/AlertContext'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import { sendFraudulentReport } from '../../ducks/report.actions'

import CardBackFile from './CardBackFile'
import CardFrontFile from './CardFrontFile'
import Comment from './Comment'
import ReporterContactInfo from './ReporterContactInfo'

const Fraudulent: React.FC = () => {
  const { payload, loading, message } = useAppSelect((state) => state.reports)
  const dispatch = useAppDispatch()
  const { showAlert } = useAlert()

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault()

    if (!payload.backImage || !payload.frontImage) {
      showAlert('please select front and back image')
      return
    }

    const formData = new FormData()

    formData.append(
      'files',
      payload?.frontImage?.[0],
      `${payload?.frontImage?.[0].name}`,
    )
    formData.append(
      'files',
      payload?.backImage?.[0],
      `${payload?.backImage?.[0].name}`,
    )
    formData.append('message', `${payload.message}`)
    formData.append('schemeIdentifier', `${payload.schemeIdentifier}`)
    formData.append('reporterName', `${payload.reporterName}`)
    formData.append('reporterEmail', `${payload.reporterEmail}`)
    formData.append('reporterTelephone', `${payload.reporterPhoneNumber}`)
    formData.append('customerName', `${payload.customerName}`)
    formData.append('registrationNumber', `${payload.registrationNumber}`)
    formData.append('cardTypeName', `${payload.cardTypeName}`)

    // The axios wrapper (src/libs/axios/index.ts) handles the captcha: if
    // no token is available it opens the captcha modal, waits for the user
    // to solve it, then sends the report with the fresh token; if a token
    // is already available it sends straight through.
    dispatch(sendFraudulentReport(formData))
  }

  return (
    <Stack
      component="form"
      encType="multipart/form-data"
      onSubmit={onSubmit}
      spacing={50}
      direction="row"
      sx={{
        '@media (max-width: 1000px)': {
          flexDirection: 'column-reverse',
          gap: (theme) => theme.spacing(25),
          '& > *': {
            marginLeft: '0 !important',
          },
        },
        '@media (max-width: 600px)': {
          gap: (theme) => theme.spacing(15),
        },
      }}
    >
      <Stack component="div" spacing={20} flex={1}>
        <ReporterContactInfo />
        <Comment />

        <Button
          type="submit"
          title={loading ? 'Processing...' : 'Submit'}
          size="large"
          sx={{ width: 152, height: 48 }}
          disabled={loading}
        />

        {message && <Typography>{message}</Typography>}
      </Stack>

      <Stack
        justifyContent="center"
        alignItems="flex-start"
        flex={0.5}
        sx={{
          height: 550,
          '@media (max-width: 1000px)': {
            height: 'auto',
            width: '100%',
            flex: 'unset',
            alignItems: 'stretch',
            p: 5,
          },
        }}
        p={15}
        spacing={10}
        borderRadius={(theme) => theme.shape.borderRadius / 8}
      >
        <CardFrontFile />
        <CardBackFile />
      </Stack>
    </Stack>
  )
}

export default Fraudulent
